// extracted by mini-css-extract-plugin
export default {"unavailableFeature":"UnavailableFeatureMessage_unavailableFeature__4SYun"};